<template>
  <div class="shipment">
    <template slot="title">
      <span>
        <span v-if="currentShipment.name">
          {{ currentShipment.name
          }}<span v-if="currentShipment.tracking_number">
            ({{ currentShipment.tracking_number }})</span
          >
        </span>
        <span v-else-if="currentShipment.tracking_number">
          {{ currentShipment.tracking_number }}
        </span>
        <span v-else> Expédition </span>
        <el-tag style="margin-left: 8px">{{
          $t("ELIXIO_CONNECT.SHIPMENT_STATUS_" + currentShipment.status)
        }}</el-tag>
      </span>
    </template>

    <shipment-item :shipment="currentShipment" @updated="reloadShipment" />
  </div>
</template>

<script>
import { Tag } from "element-ui";

import ShipmentItem from "../components/shipments/ShipmentItem.vue";

export default {
  name: "ViewShipmentComponent",
  components: {
    ShipmentItem,
    [Tag.name]: Tag,
  },
  props: {
    shipment: { type: Object, default: () => {} },
  },
  data() {
    return {
      currentShipment: this.shipment,
    };
  },
  mounted() {
    this.reloadShipment();
  },
  watch: {
    shipment: {
      handler: "getListDebounced",
      immediate: true,
    },
  },
  methods: {
    getListDebounced: _.debounce(function () {
      this.reloadShipment();
    }, 300),
    async reloadShipment() {
      const response = await this.$store.dispatch(
        "elixioConnectModule/getShipment",
        {
          shipmentId: this.shipment.id,
          serviceId: this.shipment.elixio_service_id,
        }
      );
      this.currentShipment = response ?? shipment;
      this.$emit("updated");
    },
  },
};
</script>
